import { apiClient as api } from './api';
import { 
  CodingRequest, 
  CodingResponse, 
  CodingIterateRequest, 
  CodingIterateResponse,
  MultiAgentCodingRequest,
  MultiAgentCodingResponse 
} from '../models/coding';

const CODING_SESSION_KEY = 'coding_sessions';

export const codingService = {
  // Single Agent Endpoints
  async startSession(request: CodingRequest): Promise<CodingResponse> {
    const response = await api.post<CodingResponse>('/api/agent/coding/start', request);
    return response.data;
  },

  async iterate(sessionId: string, request: CodingIterateRequest): Promise<CodingIterateResponse> {
    const response = await api.post<CodingIterateResponse>(
      `/api/agent/coding/${sessionId}`, 
      request
    );
    return response.data;
  },

  // Multi-Agent Endpoints
  async startMultiAgentSession(request: MultiAgentCodingRequest): Promise<MultiAgentCodingResponse> {
    const response = await api.post<MultiAgentCodingResponse>(
      '/api/multi-agent/coding/start', 
      request
    );
    return response.data;
  },

  // Session Management
  saveSessionToLocalStorage(sessionId: string, sessionData: any): void {
    const sessions = this.getSessionsFromLocalStorage();
    sessions[sessionId] = {
      ...sessionData,
      lastUpdated: new Date().toISOString()
    };
    localStorage.setItem(CODING_SESSION_KEY, JSON.stringify(sessions));
  },

  getSessionsFromLocalStorage(): Record<string, any> {
    const stored = localStorage.getItem(CODING_SESSION_KEY);
    return stored ? JSON.parse(stored) : {};
  },

  getSessionFromLocalStorage(sessionId: string): any {
    const sessions = this.getSessionsFromLocalStorage();
    return sessions[sessionId];
  },

  deleteSessionFromLocalStorage(sessionId: string): void {
    const sessions = this.getSessionsFromLocalStorage();
    delete sessions[sessionId];
    localStorage.setItem(CODING_SESSION_KEY, JSON.stringify(sessions));
  },

  getAllSessionIds(): string[] {
    const sessions = this.getSessionsFromLocalStorage();
    return Object.keys(sessions);
  }
};